import { AssessmentItem } from './Assessment';
import { Model, Nullable, Ordenable, Versionable } from './Model';

export enum ExamTypeEnum {
  TEST = 'TEST',
  SIMULATED = 'SIMULATED',
}

export default interface Exam extends Model, Ordenable, Versionable {
  name: string;
  description: Nullable<string>;
  type: ExamTypeEnum;
  defaultTime: number;
  coursePathId: number;
  assessmentItem: Nullable<AssessmentItem>;
  authorId: Nullable<number>;
}

export type ExamDTO = Pick<
  Exam,
  'name' | 'description' | 'defaultTime' | 'coursePathId' | 'type'
> & {
  assessmentItemId: Nullable<number>;
};
